import styled from 'styled-components';

const Subheading = styled.h2`
font-size: 2rem;
font-weight: 100;
`;

export default Subheading;